export default __webpack_public_path__ + "static/media/edit.1150b042.svg";